import React, { useState, useEffect } from 'react';
import {format } from "date-fns"
import "./bigcal.css"
import axios from 'axios';

// function formatDate(dateString) {
//   const date = new Date(dateString);
//   const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
//   return formattedDate;
// }


 function formatDate2(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}


const Calendar = (prop) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentDateChangeFlag, setCurrentDateChangeFlag] = useState(true);

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [apidata, setApidata] = useState([])
  let now_date = new Date()


  const fetchHinduCalendarDates = async () => {
      let d =  formatDate2(currentDate)

    let datas = {
      fn: "common_fn",
      se: "ge_ca",
      data: { date: d },
    };

    // console.log(datas)
    try {
      setApidata([])
      const response = await axios.post(
        "https://app.ratnasangh.com/common",
        {
          payload: JSON.stringify(datas),
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);
      setApidata(response.data)
    } catch (error) {
      console.error(error);
    }
  };


 const select_datehandler = (date) =>{

// console.log(date)
    let new_date = formatDate2(date)
    prop.dateupdate(new_date)


 }




 //----------------///

 useEffect(() => {
  if (currentDateChangeFlag) {
    fetchHinduCalendarDates();
    setCurrentDateChangeFlag(false);
  }
}, [currentDateChangeFlag]);

  
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };
  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };
  const handlePrevMonth = () => {
    const updatedDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
    setCurrentDate(updatedDate);
    setCurrentDateChangeFlag(true);
  };
  
  const handleNextMonth = () => {
    const updatedDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
    setCurrentDate(updatedDate);
    setCurrentDateChangeFlag(true);
  };



  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    const calendar = [];
    // Add empty cells for the days before the first day of the month
    for (let i = 0; i < firstDayOfMonth; i++) {
      calendar.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }
    // Add cells for each day in the month
    for (let day = 1; day <= daysInMonth; day++) {
  

    //  if( formatDate(currentDate) === apidata[0]?.Date){

    //   console.log("match both date")
    //  }

    // console.log(apidata)
      // console.log(day, apidata[day - 1]?.Date)

      
      let date_festival = apidata[day - 1]?.JainFestivals_hindi !== undefined ?  `${apidata[day - 1]?.JainFestivals_hindi}   ` :false
      let national_fes =  apidata[day - 1]?.NationalFestivals_hindi !== undefined ? ` ${apidata[day - 1]?.NationalFestivals_hindi}`:false;
      let tithi = apidata[day - 1]?.Tithi
       let hindi_tithi = apidata[day -1]?.Tithi_hindi
      let whole_date = apidata[day - 1]?.Date
 
      // let cu_date = format(modi_d ,"d-M-yyyy")

      // console.log(tithi,'cd')//
      // console.log( currentDate,"cd")


      // console.log(whole_date ,"wd")
      calendar.push(<div  key={`day-${day}`} onClick={()=> select_datehandler(new Date(year, month, day))} style={{ background:  format(now_date ,"d-M-yyyy")=== whole_date? '#D9FF87' : '' , Color :  format(now_date ,"d-M-yyyy")=== whole_date? 'pink' : ''  }} className  ={`calendar-day ${tithi === "Chaturthi" || tithi ==='Asthami' || tithi === 'Dwitiya' || tithi ==='Panchami' ||tithi === 'Ekadashi' ?'special_tithi':""}`}> <span className='DAY-1'><span style={{fontSize:'9px'}}> {hindi_tithi}</span>    {day}  </span> <div style={{ overflow: "overlay" }}><span className='DATE-1'>{date_festival?date_festival :'' }</span><span className='DATE-1'>{national_fes ? national_fes :'' }</span></div></div>);
    }
    return calendar;
  };
  return (
    <div className="calendar">
      <div className="calendar-header">
        <button onClick={handlePrevMonth}>&lt;</button>
        <h2>{currentDate.toLocaleString('en-us', { month: 'long', year: 'numeric' })}</h2>
        <button onClick={handleNextMonth}>&gt;</button>
      </div>
      <div className="calendar-body">
        {daysOfWeek.map(day => (
          <div key={day} className="calendar-day tt">{day}</div>
        ))}
        {renderCalendar()}
      </div>
    </div>
  );
};
export default Calendar;